import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'eco-footer',
    templateUrl: 'footer.component.html',
    styleUrls: ['footer.component.scss'],
})

export class FooterComponent implements OnInit {
    ngOnInit() {
    }
        
    constructor( ) {        
    }
}




